import {
  takeLatest,
  put,
  call,
  select,
} from 'redux-saga/effects';
import FileSaver from 'file-saver';
import moment from 'moment';
import { RFID_FILE_DOWNLOAD_REQUEST } from '../actions/types/RfidDownloadActionsTypes';
import {
  downloadRfidFileFailureActionCreator,
  downloadRfidFileSuccessActionCreator,
} from '../actions/RfidFileDownloadActions';
import apiFetchRfidFileDownload from '../../api/RfidFileDownloadAPI';
import { getCheckedRows } from '../../../redux/selectors/RfidUploadedFilesListSelectors';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';

function* doRfidFileDownloadWorker() {
  const lang = yield select(languageSelector);
  try {
    const items = yield select(getCheckedRows);
    const fileIds = [];
    items.map((item) => fileIds.push(item.id));
    const res = yield call(apiFetchRfidFileDownload, fileIds);

    if (fileIds.length === 1) {
      const { fileName } = items.find((item) => item.id === fileIds[0]);
      const blob = new Blob([res.data], { type: 'text/csv' });
      FileSaver.saveAs(blob, `${fileName}.csv`);
    } else if (fileIds.length > 1) {
      const blob = new Blob([res.data], { type: 'octet/stream' });
      FileSaver.saveAs(blob, `RFID_files_${moment().format('DDMMYYYY-HH.mm.ss')}.zip`);
    }

    yield put(downloadRfidFileSuccessActionCreator());
  } catch (e) {
    yield put(downloadRfidFileFailureActionCreator(e));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.rfidfile.download.failure'),
    }));
  }
}

function* doRfidFileDownloadWatcher() {
  yield takeLatest(RFID_FILE_DOWNLOAD_REQUEST, doRfidFileDownloadWorker);
}

export default doRfidFileDownloadWatcher;
